import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Shell from './core/containers/shell';
import App from './core/containers/app';
import ContactUs from './core/components/contactUs';
import CorePage from './core/containers/corePage';
import AuthPage from './auth/containers/authPage';
import RequireAuth from './auth/components/requireAuth';
import BookingPage from './booking/containers/bookingPage';
import AddressPage from './address/containers/addressPage';
import SurveyPage from './survey/containers/surveyPage';
import ProfilePage from './profile/containers/profilePage';
import TerminalsPage from './terminals/containers/terminalsPage';
import JobsPage from './jobs/containers/jobsPage';
import AdminPage from './admin/containers/adminPage';
import { modes } from './admin/constants/adminConstants';
import withFeature from './util/withFeature';
import * as coreTypes from './core/constants/coreConstants';

export default (
  <Route path="/" component={Shell}>
    <Route component={App}>
      <Route component={RequireAuth}>
        <IndexRoute component={CorePage} />
        <Route path="booking(/:jobId)(/:state)" component={BookingPage} />
        <Route path="address(/:jobId)(/:mode)" component={withFeature(coreTypes.ADDRESS_UPDATE_FEATURE, AddressPage)} />
        <Route path="profile(/:mode)" component={withFeature(coreTypes.PORTAL_FEATURE, ProfilePage)} />
        <Route path="survey(/:jobId)(/:surveyId)" component={SurveyPage} />
        <Route path="terminals(/:terminalId)" component={withFeature(coreTypes.PORTAL_FEATURE, TerminalsPage)} />
        <Route path="jobs(/:status)" component={withFeature(coreTypes.PORTAL_FEATURE, JobsPage)} />
        <Route path="job(/:jobId)" component={withFeature(coreTypes.PORTAL_FEATURE, JobsPage)} />
      </Route>
      <Route path="auth" component={AuthPage} />
      <Route path="contactus(/:mode)(/:referenceNumber)" component={ContactUs} />
    </Route>
    <Route path="admin/addressUpdate" mode={modes.addressUpdate} component={AdminPage} />
  </Route>
);


// WEBPACK FOOTER //
// ./app/routes.js